export default "__VITE_ASSET__o5Kg4t1x__"